module.exports = __webpack_public_path__ + "img/14.61cc4c62.jpg";